import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import fontawesome from '@fortawesome/fontawesome'
import { GlobalNav } from 'callahan-react'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Redirect, Route, BrowserRouter as Router, Switch } from 'react-router-dom'

import { ADMIN_BASE_URL } from './constants/route-constants'
import ProtectedPage from './pages/ProtectedPage/ProtectedPage'
import registerServiceWorker from './registerServiceWorker'
import store from './store'

import 'callahan-react/css/callahan.css'

fontawesome.library.add(faChevronLeft)

ReactDOM.render(
  <div>
    <GlobalNav config={{}} />
    <Provider store={store}>
      <Router>
        <Switch>
          <Route path={ADMIN_BASE_URL} component={ProtectedPage} />
          <Redirect from={'/admin'} to={ADMIN_BASE_URL} />
        </Switch>
      </Router>
    </Provider>
  </div>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js